import axios from 'axios';

// const culture = document.documentElement.lang;

const apiService = {
    store: {
        getStores(country, customerNumbers) {
            const params = { country };

            if (customerNumbers) {
                params.customerNumbers = customerNumbers;
            }

            return axios.get('/Umbraco/Api/StoreApi/GetStores', { params }).then(response => response);
        }
    }
};

export default apiService;
